import api from './api';

const agentService = {
  // 取得儀表板資料
  getDashboard: async () => {
    return await api.get('/agent/manage/dashboard');
  },

  // 取得下級代理列表
  getSubAgents: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/manage/sub-agents?${queryString}`);
  },

  // 新增下級代理
  createAgent: async (data) => {
    return await api.post('/agent/manage/create-agent', data);
  },

  // 取得直屬會員列表
  getMembers: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/manage/members?${queryString}`);
  },

  // 新增會員
  createMember: async (userId) => {
    return await api.post('/agent/manage/create-member', { userId });
  },

  // 轉移會員
  transferMember: async (data) => {
    return await api.post('/agent/manage/transfer-member', data);
  },

  // 批量轉移會員
  batchTransferMembers: async (data) => {
    return await api.post('/agent/manage/batch-transfer-members', data);
  },

  // 移除會員
  removeMember: async (userId, reason) => {
    return await api.post('/agent/manage/remove-member', { userId, reason });
  },

  // 新增：取得所有下級會員（含代理結構）
  getAllMembers: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/manage/all-members?${queryString}`);
  },

  // 新增：批量管理會員
  batchManageMembers: async (data) => {
    return await api.post('/agent/manage/batch-manage-members', data);
  },

  // 新增：更新代理設定（整合額度和佣金）
  updateAgent: async (agentId, data) => {
    return await api.put(`/agent/manage/update-agent/${agentId}`, data);
  },

  // 新增：取得額度記錄
  getCreditRecords: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/manage/credit-records?${queryString}`);
  },

  // 觀察者管理相關 API

  // 創建觀察者帳號
  createObserver: async (data) => {
    return await api.post('/agent/manage/create-observer', data);
  },

  // 取得觀察者列表
  getObservers: async (params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/manage/observers?${queryString}`);
  },

  // 刪除觀察者帳號
  deleteObserver: async (observerId) => {
    return await api.delete(`/agent/manage/observer/${observerId}`);
  },

  // 更新觀察者狀態
  updateObserverStatus: async (observerId, status) => {
    return await api.put(`/agent/manage/observer/${observerId}/status`, { status });
  },

  // 投注狀態管理相關 API

  // 設定會員投注狀態
  setMemberBettingStatus: async (data) => {
    return await api.post('/agent/manage/set-member-betting-status', data);
  },

  // 批量設定會員投注狀態
  batchSetBettingStatus: async (data) => {
    return await api.post('/agent/manage/batch-set-betting-status', data);
  },

  // 查詢會員投注狀態歷史
  getMemberBettingHistory: async (userId, params) => {
    const queryString = new URLSearchParams(params).toString();
    return await api.get(`/agent/manage/member-betting-history/${userId}?${queryString}`);
  },

  // 代理帳號保護機制相關 API

  // 解鎖被鎖定的代理帳號
  unlockAgent: async (agentId, reason) => {
    return await api.post(`/agent/manage/unlock-agent/${agentId}`, { reason });
  },

  // 查詢代理登入狀態
  getAgentLoginStatus: async (agentId) => {
    return await api.get(`/agent/manage/agent-login-status/${agentId}`);
  },

  // Stage 2: 代理停用/啟用/刪除 API

  // 檢查代理是否可刪除
  checkAgentDeletable: async (agentId) => {
    return await api.get(`/agent/manage/check-agent-deletable/${agentId}`);
  },

  // 停用代理
  suspendAgent: async (agentId, reason) => {
    return await api.put(`/agent/manage/suspend-agent/${agentId}`, { reason });
  },

  // 啟用代理
  activateAgent: async (agentId, reason) => {
    return await api.put(`/agent/manage/activate-agent/${agentId}`, { reason });
  },

  // 停用整條線
  suspendAgentTree: async (agentId, reason) => {
    return await api.put(`/agent/manage/suspend-agent-tree/${agentId}`, { reason });
  },

  // 啟用整條線
  activateAgentTree: async (agentId, reason) => {
    return await api.put(`/agent/manage/activate-agent-tree/${agentId}`, { reason });
  },

  // 刪除代理
  removeAgent: async (agentId, reason) => {
    return await api.delete(`/agent/manage/remove-agent/${agentId}`, {
      data: { reason }
    });
  },

  //獲取級聯刪除預覽
  getCascadeDeletePreview: async (agentId) => {
    return await api.get(`/agent/manage/cascade-delete-preview/${agentId}`);
  },

  //執行級聯刪除
  cascadeDeleteAgent: async (agentId, data) => {
    return await api.delete(`/agent/manage/cascade-delete-agent/${agentId}`, {
      data: data // { password: string, reason?: string }
    });
  }
};

export default agentService;